import { useState } from "react"

export const ToolStates = () => {
    const [prefetch, setPrefetch] = useState(false)
    const [__SESSION, setSession] = useState({ainfo: null, pinfo: null})
    const [userId, setUserId] = useState()

    const [toolShuffle, setToolShuffle] = useState([]);

    const [checkEmail, setCheckEmail] = useState(false)
    const [getEmail, setGetEmail] = useState('')
    const [getLicense, setGetLicense] = useState()
    const [vCode, setVCode] = useState('')
    const [verifyCode, setVerifyCode] = useState(false)
    const [notifications, setNotifications] = useState({
        anchor: null,
        list: null,
        push: {
            request: {stat: false, step: 1}
        },
        mono_snack: {
            toggled: false,
            msg: '',
            vertical: 'top',
            horizontal: 'center',
            duration: 2000
        }
    })
    const [switching, setSwitching] = useState({biz: {stat: false, list: null}})
    const [ownedTools, setOwnedTools] = useState({stat: false, list: null, selected: null})
   
    //wordpress
    const [dataTraining, setDataTraining] = useState({ainfo: null, accountDetails: null, link: null, prclicense: null})
    const [identifier,setIdentifier] = useState ('summary')

    //Added State
    const [tlist, setTlist] = useState({owned: null, cart: null, nya: null, preview: {stat: false, value: null}, categories: {active: 0, list: null}})
    const [MTlist, setMTlist] = useState([])
    const [preview, setpreview] = useState({open: false, data: null })
    const [tclist, setTCList] = useState(null)
    const [category, setCategory] = useState({selected: null, tools: null})

    //PRE LOAD FOR SWITCHING TOOLS
    const [preload, setPreload] = useState({loader:false, logo:''}) 

    //GLOBAL STATE
    const [globalLoader, setGlobalLoader] = useState(true)
    
    const [toolOwned, setToolOwned] = useState([])
    
    const [validateAccount, setValidateAccount] = useState({data:'', count:0})
    
    const [profession, setProfession] = useState([{profid: 'all', name: 'All'}])
    const [openPModal, setOpenPModal ] = useState(false)

    //Maintenance
    const [isMaintenance, setIsMaintenance] = useState(false)

    //PROFESSIONAL STATE
    const [pData, setPData] = useState({first_name: '' , middle_name:'', last_name: '', suffix: '', prc_id_expiry_date:'', profession:'', prc_license:null });
    const [invalidNo, setInvalidNo] = useState(false);
    const [validDate, setValidDate] = useState(false);
    const [isLoader, setIsLoader] = useState(false);
    const [errors, setErrors] = useState({ 
        profession: false,
        prc_license_num: false,
        prc_expiry_date: false,
    });
    

    return {
        prefetch: {data: prefetch, set: setPrefetch},
        __SESSION: {data: __SESSION, set: setSession},
        userId: {data: userId, set: setUserId},

        toolShuffle: {data: toolShuffle, set: setToolShuffle},

        checkEmail: {data:checkEmail, set: setCheckEmail},
        getEmail: {data:getEmail, set: setGetEmail},
        dataTraining: {data: dataTraining, set: setDataTraining},
        identifier: {data: identifier, set: setIdentifier},
        getLicense: {data: getLicense, set: setGetLicense},
        vCode: {data:vCode, set: setVCode},
        verifyCode: {data:verifyCode, set: setVerifyCode},
        notifications: {data: notifications, set: setNotifications},
        switching: {data: switching, set: setSwitching},
        ownedTools: {data: ownedTools, set: setOwnedTools},

        //PROFESSIONAL STATE
        pData: {data: pData, set: setPData},
        errors: {data: errors, set: setErrors},
        isLoader: {data: isLoader, set: setIsLoader},
        invalidNo:{ data: invalidNo, set: setInvalidNo},
        validDate:{ data: validDate, set: setValidDate},
        
        //PRE LOAD FOR SWITCHING TOOLS
        preload: {data: preload, set: setPreload},

        //GLOBAL STATE
        globalLoader: {data: globalLoader, set: setGlobalLoader},
        toolOwned: {data: toolOwned, set: setToolOwned},

        validateAccount: {data: validateAccount, set: setValidateAccount},
        profession: {data: profession, set: setProfession},
        openPModal: {data: openPModal, set: setOpenPModal},

        tlist: {data: tlist, set: setTlist},
        MTlist: {data: MTlist, set: setMTlist},
        preview: {data: preview, set: setpreview},
        tclist: {data: tclist, set: setTCList},
        category: {data: category, set: setCategory, graph: {load: 'loader', labels: [], datasets: []}},

        //Maintenance
        mnt: {data: isMaintenance, set: setIsMaintenance},
    }
}

// import { useState } from "react"

// export const ToolStates = () => {
//     const [prefetch, setPrefetch] = useState(false)
//     const [__SESSION, setSession] = useState({ainfo: null, pinfo: null})
//     const [userId, setUserId] = useState()

//     //PRE LOAD FOR SWITCHING TOOLS
//     const [preload, setPreload] = useState({loader:false, logo:''}) 

//     //GLOBAL STATE
//     const [globalLoader, setGlobalLoader] = useState(true)

//     const [toolOwned, setToolOwned] = useState([])

//     const [validateAccount, setValidateAccount] = useState({data:'', count:0})

//     return {
//         prefetch: {data: prefetch, set: setPrefetch},
//         __SESSION: {data: __SESSION, set: setSession},
//         userId: {data: userId, set: setUserId},

//         //PRE LOAD FOR SWITCHING TOOLS
//         preload: {data: preload, set: setPreload},

//         //GLOBAL STATE
//         globalLoader: {data: globalLoader, set: setGlobalLoader},
//         toolOwned: {data: toolOwned, set: setToolOwned},

//         validateAccount: {data: validateAccount, set: setValidateAccount}
//     }
// }

